export enum InstallationTechnology {
  LoraWan = 'lora_wan',
  NBIoT = 'nb_iot',
  Other = 'other',
}
